import { render, staticRenderFns } from "./UpgradeFunnelThemeModal.vue?vue&type=template&id=642e7a74"
import script from "./UpgradeFunnelThemeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeFunnelThemeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports